import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import {
  BackgroundCheck,
  BackgroundCheckStatus
} from "@wingspanhq/wingspan-api-sdk";

import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { RequirementTableItemData } from "../../../../types";

export const payerBackgroundCheckRenderCardDescription = (
  requirement: RequirementTableItemData,
  backgroundCheck?: BackgroundCheck
) => {
  const descriptions: Record<BackgroundCheckStatus, WSEmptyStateProps> = {
    [BackgroundCheckStatus.NEW]: {
      type: "search",
      title: "Your payer has requested a background check to be completed",
      description:
        "You will receive an email with instructions shortly to start the process."
    },
    [BackgroundCheckStatus.PENDING]: {
      type: "search",
      title: "Your payer has requested a background check to be completed",
      description:
        "Click start to open the background check portal in a new window. When you’ve finished with your background check requirement, return to Wingspan to complete your onboarding. You can access the portal and check the status from your Wingspan homepage."
    },
    [BackgroundCheckStatus.PROCESSING]: {
      type: "search",
      title: "Your background check is being processed",
      description:
        "This typically takes 1-3 business days. Your payer will be notified when it is complete."
    },
    [BackgroundCheckStatus.SUCCESS]: {
      type: "done",
      title: "Your background check is complete",
      description:
        "You can access the report in the background check portal. Your payer will also be notified."
    },
    [BackgroundCheckStatus.FAILED]: {
      type: "search",
      title: "Something went wrong with your background check",
      description: "Please contact your payer to resolve this issue."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: backgroundCheck?.status || BackgroundCheckStatus.NEW,
    documentStatuses: descriptions,
    pendingApprovalStatus: null,
    rejectedStatus: null,
    approvedStatus: null
  });
};
